import { Col, Divider, Row, Typography } from 'antd';
import { InfoField } from 'components/Create/common/InfoField';
import { TimeZoneText } from 'components/common/TimeZoneText';
import { formatChoiceStatusRaw } from 'helpers/formatChoiceStatus';
import Cookies from 'js-cookie';
import { SparingOrder } from 'models/PostedSpareOrder';
import moment from 'moment-timezone';
import { FC } from 'react';
import { useAppSelector } from 'redux/store';

const styles = {
  heading: {
    color: 'rgb(47, 85, 150)',
    fontWight: 'bold',
    whiteSpace: 'nowrap' as const
  },
  // Break between words only, never inside a date.
  wholeWords: {
    wordBreak: 'normal' as const,
    overflowWrap: 'normal' as const
  }
};

interface Props {
  sparingOrder: SparingOrder;
}

const getCookie = (): boolean => {
  const cookie = Cookies.get('isLocalTimeZone');
  const parsedCookie = cookie ? JSON.parse(cookie) : false;

  if (parsedCookie) return true;

  return false;
};

export const CollapseRowHeader: FC<Props> = ({ sparingOrder }): JSX.Element => {
  const { deliveryAddressTimeZoneInfo } = useAppSelector((state) => state.form);

  const time = moment.utc(sparingOrder.modifiedDateTime).tz('America/New_York').format('MM/DD/YYYY hh:mm A');

  const utcTime = moment.utc(sparingOrder.modifiedDateTime).format('MM/DD/YYYY HH:mm');

  const formatSLA = (sparingOrder: SparingOrder): string => {
    switch (sparingOrder.serviceLevelAgreement) {
      case 'NextBusinessDay':
        return 'NBD';

      case 'NextFlightOut':
        return 'NFO';

      case 'WillCall':
        return 'Will Call';

      default:
        return 'Rush';
    }
  };

  return (
    <div>
      <Row gutter={[10, 0]} align={'top'}>
        <Col>
          <InfoField style={{ columnGap: 5 }}>
            <Typography.Text style={styles.heading}>Sparing Order:</Typography.Text>
            <Typography.Text>{sparingOrder.salesOrderNumber || 'Failed'}</Typography.Text>
          </InfoField>
        </Col>
        <Col>
          <InfoField style={{ columnGap: 5 }}>
            <Typography.Text style={styles.heading}>Warehouse:</Typography.Text>
            <Typography.Text>{sparingOrder.warehouseId}</Typography.Text>
          </InfoField>
        </Col>
        <Col>
          <InfoField style={{ columnGap: 5 }}>
            <Typography.Text style={styles.heading}>SLA: </Typography.Text>
            <Typography.Text>{formatSLA(sparingOrder)}</Typography.Text>
          </InfoField>
        </Col>
        <Col>
          <InfoField style={{ columnGap: 5 }}>
            <Typography.Text style={styles.heading}>Delivery Method:</Typography.Text>
            <Typography.Text>{sparingOrder.trackingInformation.shipMethod}</Typography.Text>
          </InfoField>
        </Col>
        <Col>
          <InfoField style={{ columnGap: 5 }}>
            <Typography.Text style={styles.heading}>Current Status:</Typography.Text>
            <Typography.Text>{formatChoiceStatusRaw(sparingOrder)}</Typography.Text>
          </InfoField>
        </Col>
        <Col>
          <Typography.Text style={styles.heading}>Last Updated:</Typography.Text>
          {/* <TimeZoneText spaceStyle={{ marginLeft: 5 }} timezoneData={deliveryAddressTimeZoneInfo} dateTime={sparingOrder.modifiedDateTime} spaceSize={0} divider /> */}
          <Typography.Text style={{ marginLeft: 5, ...styles.wholeWords }}>{utcTime} UTC</Typography.Text>
          <Divider type="vertical" style={{ borderColor: 'black' }} />
          <Typography.Text style={styles.wholeWords}>{time} EST</Typography.Text>
        </Col>
      </Row>
      <Row gutter={[12, 0]}>
        <Col>
          <Typography.Text style={styles.heading}>Current ETA:</Typography.Text>
          <TimeZoneText spaceStyle={{ marginLeft: 5 }} timezoneData={deliveryAddressTimeZoneInfo} dateTime={sparingOrder.estimatedDeliveryDate} spaceSize={0} divider />
        </Col>
      </Row>
    </div>
  );
};
